module.exports = __webpack_public_path__ + "img/Imagenes Kia-05.cd739f3c.png";